import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
    {path: '', loadChildren: () => import('../app/core/core.module').then((m) => m.CoreModule)},
];

/**
 * Defines the routing configuration for the Angular application.
 * The routes constant defines an array of routes, which maps the root path ('') to the CoreModule using lazy loading.
 */
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
